import { useCallback } from "preact/hooks";
import { com } from "../../proto/game.pb";
import { useWebSocket } from "../contexts";

/**
 * Хук для отладки и тестирования
 * Содержит функции только для разработки, не будет в продакшене
 */
export function useDebugTools() {
  const { sendProto } = useWebSocket();

  /**
   * Отправляет на сервер принудительный краш поинт
   * @param crashPoint - множитель для краша (0 = выключить, >0 = форсировать)
   */
  const setForcedCrashPoint = useCallback(
    (crashPoint: number): boolean => {
      try {
        const msg: com.achlid.crash.game.IGameMessage = {
          type: com.achlid.crash.game.GameMessage.MessageType
            .SET_FORCED_CRASH_POINT,
          timestamp: Date.now(),
          setForcedCrashPoint: {
            crashPoint,
          },
        };

        const sent = sendProto(msg);

        if (sent) {
          console.log(
            `[DEBUG] Отправлен краш поинт: ${crashPoint === 0 ? "выключен" : `${crashPoint}x`}`
          );
        } else {
          console.warn(
            "[DEBUG] Не удалось отправить краш поинт - WebSocket не готов"
          );
        }

        return sent;
      } catch (error) {
        console.error("[DEBUG] Ошибка при отправке краш поинта:", error);
        return false;
      }
    },
    [sendProto]
  );

  /**
   * Выключает принудительный краш поинт
   */
  const disableForcedCrashPoint = useCallback((): boolean => {
    return setForcedCrashPoint(0);
  }, [setForcedCrashPoint]);

  return {
    setForcedCrashPoint,
    disableForcedCrashPoint,
  };
}
